export default __webpack_public_path__ + "static/texture-43823fd9e2d42f6b7401a41a84200856.png";